import '../scss/theme.scss'

import SimpleLightbox from "simplelightbox";
import 'simplelightbox/src/simple-lightbox.scss'

window.addEventListener('load', () => {
    console.log('theme ready')
})

wp.data.dispatch('core/block-editor').updateSettings({
    colors: [{name: 'test', slug: 'test', color: '#00FF00'}]
})

function loadSlick() {
    return new Promise((resolve, reject) => {
        if (typeof Slick !== 'undefined') {
            console.log('already available')
            resolve()
            return
        }

        const js = import('slick-carousel/slick/slick.js')
        const css = import('slick-carousel/slick/slick.css')

        window.Slick = js

        Promise.all([js, css]).then(() => {
            console.log('loaded dependencies')
            resolve()
        })
    })
}

const initQuoteArrows = () => {
    document.querySelectorAll('.slick-center').forEach(item => item.addEventListener('click', e => {
        if (e.target.classList.contains('slick-slide')) {
            const cite = e.target.querySelector('cite')
            if (cite) {
                const citeBox = cite.getBoundingClientRect()
                const center = citeBox.left + (citeBox.width / 2)

                if (e.clientX < center) {
                    jQuery('.quotes ul').slick('slickPrev')
                } else {
                    jQuery('.quotes ul').slick('slickNext')
                }
            }
        }
    }))
}

const checkScroll = () => {
    if (window.scrollY > 200 && document.body.classList.contains('top')) {
        document.body.classList.remove('top')
    }
    else if (window.scrollY <= 200 && !document.body.classList.contains('top')) {
        document.body.classList.add('top')
    }
}

window.addEventListener('load', () => {
    loadSlick().then(() => {
        jQuery('.quotes ul')
            .on('init', () => {
                initQuoteArrows()
            })
            .slick({
                centerMode: true,
                centerPadding: '26%',
                slidesToShow: 1,
                arrows: false,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                            centerPadding: '20%'
                        }
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            centerPadding: '7%'
                        }
                    }
                ]
            })
            .on('afterChange', () => {
                initQuoteArrows()
            })
    })

    checkScroll()
    window.addEventListener('scroll', checkScroll)

    document.getElementById('arrow-up').addEventListener('click', () => window.scrollTo({top: 0, behavior: 'smooth'}))

    new SimpleLightbox('.wp-block-gallery a')
})
